module.exports = __webpack_public_path__ + "static/img/homebanner2.225801cc.jpg";